import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  // Contract Modal
  isContractModalOpen: false,
  contractModalType: null,
  currentContract: null,

  // Client Modal
  isClientModalOpen: false,
  clientModalType: null,
  currentClient: null,

  // Unit Modal
  isUnitModalOpen: false,
  unitModalType: null,
  currentUnit: null,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    // --- CONTRACT MODAL ---
    openContractModal(state, action) {
      const { modalType, contract } = action.payload;
      state.isContractModalOpen = true;
      state.contractModalType = modalType || null;
      state.currentContract = contract || null;
    },
    closeContractModal(state) {
      state.isContractModalOpen = false;
      state.contractModalType = null;
      state.currentContract = null;
    },

    // --- CLIENT MODAL ---
    openClientModal(state, action) {
      const { modalType, client } = action.payload;
      state.isClientModalOpen = true;
      state.clientModalType = modalType || null;
      state.currentClient = client || null;
    },
    closeClientModal(state) {
      state.isClientModalOpen = false;
      state.clientModalType = null;
      state.currentClient = null;
    },

    // --- UNIT MODAL ---
    openUnitModal(state, action) {
      const { modalType, unit } = action.payload;
      state.isUnitModalOpen = true;
      state.unitModalType = modalType || null;
      state.currentUnit = unit || null;
    },
    closeUnitModal(state) {
      state.isUnitModalOpen = false;
      state.unitModalType = null;
      state.currentUnit = null;
    },
  },
});

export const {
  openContractModal,
  closeContractModal,
  openClientModal,
  closeClientModal,
  openUnitModal,
  closeUnitModal,
} = modalSlice.actions;

export default modalSlice.reducer;
